module.exports = __webpack_public_path__ + "media/images/icons/courses/4-c0a02f61aa0ebfec441ae67d080fe0a3.svg";